/**
 * @module app.bdc.list.createUpdateClientCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function CreateUpdateClientCtrl(
        $scope,
        $rootScope,
        $uibModalInstance,
        clientService,
        $log,
        order,
        Notification,
        marketService,
        storeTypeService,
        walletService
    ) {
        var self = {};
        self.order = order;
        self.storeType = $scope.orderForm.storeTypes;

        if (!self.order.client.id && !self.order.client.storeId) {
            self.order.client = clientService.getClientObject();
        }
        else if (self.order.client.storeType === null) {
            self.order.client.storeType = {
                id: null,
                code: null,
                label: null
            };
        }

        // storeType initialisation
        if (self.order.client.storeType.id === null) {
            self.order.client.storeType = {
                id: self.storeType[0].id,
                code: self.storeType[0].code,
                label: self.storeType[0].label
            };
        }

        self.isCreationLoading = false;

        self.ok = function() {
            $uibModalInstance.close(self.order);
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        /**
         * Is a client update
         * @return {Boolean}
         */
        self.isUpdate = function isUpdate() {
            return self.order.client.id;
        };

        /**
         * Create a client during the order creation
         */
        self.createClient = function createClient() {
            self.isCreationLoading = true;
            // récupération de toutes les informations du storeType à partir de son code

            if (self.order.orderType.code === 'NAP') {
                self.order.client.storeType = storeTypeService.getStoreTypeByCode(self.order.client.storeType.code);
            }
            else {
                self.order.client.storeType = {
                    id: null,
                    code: null,
                    label: null
                };
            }
            clientService
                .createUpdate(self.order.client)
                .then(function(client) {
                    if (self.order.client.id) {
                        Notification.success('Le client a bien été mis à jour');
                    }
                    self.order.client = client;
                    return client;
                })
                .then(function(clnt) {
                    walletService.getStoreBusinesses(clnt.id).then(function(businesses) {
                        let business = businesses.find(bus => bus.businessStatusId <= 2);
                        self.order.business = business !== undefined && self.order.fromOrder === undefined
                            ? business.businessId : business !== undefined && self.order.fromOrder ? business : null;
                        self.ok();
                    });
                })
                .catch(function(err) {
                    $log.error(err);
                    Notification.error('Une erreur est survenue : ' + err.data);
                })
                .finally(function() {
                    self.isCreationLoading = false;
                });
        };

        self.activities = marketService.getActivitiesList(self.order.marketType.code);
        // storeActivityId initialisation
        if (typeof self.order.client.storeActivityId === 'undefined') {
            self.order.client.storeActivityId = self.activities[0].id;
        }
        return self;
    }

    CreateUpdateClientCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'clientService',
        '$log',
        'order',
        'Notification',
        'marketService',
        'storeTypeService',
        'walletService'

    ];

    angular
        .module('app.bdc.list.createUpdateClientCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('CreateUpdateClientCtrl', CreateUpdateClientCtrl);
});
